module.exports = __webpack_public_path__ + "static/img/01031A_2_4_R_20181115_LC.b1f92a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01031A_2_4_R_20181115_LC.png
// module id = Y9/y
// module chunks = 0